import React from "react";
import PropTypes from "prop-types";
import PublicCatalogLayout from "../layouts/PublicCatalogLayout"
import ReceivingListTable from "./ReceivingListTable"
const ReceivingListDashboard = (props) => {
  const { user } = props;


  return (
    <PublicCatalogLayout 
      currentPage="home"
      classNames={{container: 'full-width-container'}}
      {...props}
    >
      <h1
        className="catalog-h1"
      >
        Receiving List
      </h1>
      <ReceivingListTable 
        {...props}
      />
    </PublicCatalogLayout>
  );
}

export default ReceivingListDashboard;
